module.exports = __webpack_public_path__ + "static/media/internship.52a84ebd.png";